export default __webpack_public_path__ + "static/media/48.590521c9.png";